import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGetPolicyListResponse } from 'src/app/state/policy/policy.models';
import { environment } from 'src/environments/environment';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';

export interface queryGetPolicyList {
  idPoliza?: number;
  idEntidad?: number;
  idCliente?: number;
  numPoliza?: string;
  aliasEstado?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PolizasService {
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiPolicy}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  getObjetos() {
    return this.http.get<any>(`${this.url}/GetObjects`);
  }

  getDetallesObjeto(idPoliza: number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetDetailObjectsbyCustomer/${idPoliza}`);
  }

  getDiasRestantes(idPoliza: number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetEndDays/${idPoliza}`);
  }

  sendEsign(idMovimiento): Observable<any> {
    return this.http.get<any>(
      `${this.url}/GetSign/${idMovimiento}`
    );
  }

  getPolicyList( data?: queryGetPolicyList): Observable<IHttpResponse<IGetPolicyListResponse[]>> {
    let query;
    
    if(data){
      query = Object.keys(data)
        .map((key) => `${key}=${data[key]}`)
        .join('&');
    }

    return this.http.get<IHttpResponse<IGetPolicyListResponse[]>>(`${this.url}/GetList?${query}`);
  }
}
